import { InjectionToken } from '@angular/core';
import { IPredictionGameService } from '../interfaces/prediction-game-service';

export const PREDICTION_GAME_SERVICE = new InjectionToken<IPredictionGameService>('PREDICTION_GAME_SERVICE');
